<template>
  <div>
    <b-card>
      <b-card-header>
        <h2>
          <feather-icon icon="LayersIcon" />
          {{ $t('AppTI.filters.provider') }}
        </h2>
      </b-card-header>
      <b-card-body>
        <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
          <b-form @submit.prevent="handleSubmit(onSubmit)" @reset.prevent="resetForm">
            <b-row>
              <b-col cols="12" md="6">
                <validation-provider #default="{errors}" :name="$t('AppTI.columns.name')" rules="required|max:150">
                  <b-form-group>
                    <h4>{{ $t('AppTI.columns.name') }}</h4>
                    <b-form-input type="text" :placeholder="$t('AppTI.columns.name')"  v-model="providerData.nombre"/>
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" md="6">
                <validation-provider #default="{errors}" :name="$t('AppTI.provider.alias')" rules="required|max:10">
                  <b-form-group>
                    <h4>{{ $t('AppTI.provider.alias') }}</h4>
                    <b-form-input type="text" :placeholder="$t('AppTI.provider.alias')"  v-model="providerData.alias"/>
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" md="6">
                <validation-provider
                  #default="{errors}"
                  :name="$t('AppTI.provider.rfc')"
                  rules="required|max:13|min:12"
                >
                  <b-form-group>
                    <h4>{{ $t('AppTI.provider.rfc') }}</h4>
                    <b-form-input
                      v-model="providerData.rfc"
                      type="text"
                      :placeholder="$t('AppTI.provider.rfc')"
                      onkeyup="this.value = this.value.toUpperCase();"
                    />
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" md="6">
                <validation-provider #default="{errors}" :name="$t('AppTI.provider.address')" rules="required|max:250">
                  <b-form-group>
                    <h4>{{ $t('AppTI.provider.address') }}</h4>
                    <b-form-input type="text" :placeholder="$t('AppTI.provider.address')"  v-model="providerData.domicilio"/>
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" md="6">
                <validation-provider #default="{errors}" :name="$t('AppTI.columns.email')" rules="required|email|max:150">
                  <b-form-group>
                    <h4>{{ $t('AppTI.columns.email') }}</h4>
                    <b-form-input type="text" :placeholder="$t('AppTI.columns.email')"  v-model="providerData.correo"/>
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row class="float-right mt-2 mb-2">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mr-2" type="submit">
                <b-spinner v-if="addingTicket" small class="mr-1" />
                {{ $t('Lists.Add') }}
              </b-button>
            </b-row>
          </b-form>
        </validation-observer>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BButton,
  BForm,
  BFormInput,
  BFormGroup,
  BFormInvalidFeedback,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import {
  required,
} from '@validations'
import tiService from '@/services/informationTecnology.service'
import formValidation from '@core/comp-functions/forms/form-validation'
import router from '@/router'
import { ref } from '@vue/composition-api'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BRow,
    BCol,
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BFormInvalidFeedback,

    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  setup() {
    const blankProviderData = {
      proveedorTiId: null,
      nombre: '',
      alias: '',
      rfc: '',
      domicilio: null,
      correo: '',
    }

    const addingProvider = ref(false)
    const providerData = ref(JSON.parse(JSON.stringify(blankProviderData)))

    const resetProviderData = () => {
      providerData.value = JSON.parse(JSON.stringify(blankProviderData))
    }

    const {
      refFormObserver,
      resetForm,
    } = formValidation(resetProviderData)
    const { createProvider } = tiService()
    const onSubmit = () => {
      addingProvider.value = true
      createProvider(providerData.value)
        .then(() => {
          addingProvider.value = false
          router.push({ name: 'apps-provider-list' })
        })
    }
    return {
      refFormObserver,
      resetForm,
      providerData,
      onSubmit,
    }
  },
}
</script>
